import React from 'react'
import { useForm } from 'react-hook-form'

import { UserTokenError } from '@models/userToken.model'
import { useGenerateTokenMutation } from '@services/UserToken'

interface FormData {
	email: string
}

export default function UserToken() {
	const [generateToken, { data, isLoading, error, isError, isSuccess, reset }] =
		useGenerateTokenMutation()

	const {
		register,
		handleSubmit,
		formState: { errors, isValid },
	} = useForm<FormData>({
		mode: 'onChange',
	})

	const onSubmit = (formData: FormData) => {
		reset()
		generateToken({ email: formData.email })
	}

	return (
		<div className='flex items-center justify-center min-h-screen bg-gray-50'>
			<form
				onSubmit={handleSubmit(onSubmit)}
				className='w-full max-w-md p-8 bg-white border rounded shadow'
			>
				<h1 className='mb-6 text-xl font-semibold text-center'>
					Gerar Token do Usuário
				</h1>

				<label className='block mb-2 text-sm font-medium'>
					E-mail do cliente
					<input
						type='email'
						{...register('email', {
							required: 'Email é obrigatório',
							pattern: {
								value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
								message: 'Email deve ter um formato válido',
							},
						})}
						className={`w-full px-3 py-2 mb-1 border rounded outline-none focus:border-primary-500 ${
							errors.email ? 'border-red-500' : 'border-gray-300'
						}`}
						placeholder='cliente@email.com'
					/>
					{errors.email && (
						<p className='text-red-500 text-xs mt-1'>{errors.email.message}</p>
					)}
				</label>

				<button
					type='submit'
					disabled={isLoading || !isValid}
					className='w-full py-2 font-semibold text-black bg-primary-500 rounded border-black disabled:opacity-50'
				>
					{isLoading ? 'Gerando token' : 'Gerar token'}
				</button>

				{isError && (
					<div className='mt-4 p-3 bg-red-100 border border-red-300 rounded'>
						<p className='text-red-700 font-medium'>Erro:</p>
						<p className='text-red-600 text-sm'>
							{(error as UserTokenError)?.data?.message ||
								'Erro ao gerar token'}
						</p>
					</div>
				)}

				{isSuccess && data && (
					<div className='mt-6 p-4 bg-green-50 border border-green-200 rounded'>
						<h3 className='font-medium text-green-800 mb-3'>Token gerado</h3>

						<div className='text-sm space-y-2'>
							<p>
								<strong>ID:</strong> {data.id}
							</p>
							<p>
								<strong>Email:</strong> {data.email}
							</p>

							<div>
								<p className='font-medium mb-2'>Token:</p>
								<textarea
									readOnly
									rows={4}
									className='w-full p-2 font-mono text-xs border rounded resize-none bg-gray-50'
									value={data.token}
									onClick={(e) =>
										(e.currentTarget as HTMLTextAreaElement).select()
									}
								/>
							</div>
						</div>
					</div>
				)}
			</form>
		</div>
	)
}
